export default __webpack_public_path__ + "static/blog-images@2x-cfa9d16e1e55a4a94e759e4774260119.png";